import { Component } from "react";
import {
    withRouter
} from 'react-router-dom';

import {
    TopBar, SkeletonDisplayText, Icon, Popover, Text, Spinner, Tabs, Badge, ActionList, Button, BlockStack,
} from "@shopify/polaris";
import './index.css'

// shopify icon
import {
    // HomeMajor,
    MobileCancelMajor,
    LanguageMinor,
} from '@shopify/polaris-icons';

// api
import {
    reqUpdateLanguage,
    reqGetStatisticsMessage,
    reqUpdateStatisticsMessages,
    reqDeleteStatisticsMessages,
    reqGetMessageTabsInfo,
} from '../../../api';

// Icon图标
// import StarIcon from '../../../assets/StarIcon';
import News from '../../../assets/News';
// import SeoCheckerIcon from '../../../assets/SeoCheckerIcon';
// import MoneyIcon from '../../../assets/MoneyIcon';
// import IntegrationIcon from '../../../assets/IntegrationIcon';
import UnreadIcon from "../../../assets/UnreadIcon";
import CloseNewsIcon from "../../../assets/CloseNewsIcon";
// import FeatureRequestIcon from "../../../assets/FeatureRequestIcon";

// 组件
// import NewReviewModal from "../../../components/ReviewModal";
import InfiniteScroll from 'react-infinite-scroll-component';

// 获取全局公共数据
import { connect } from 'react-redux'
import { changeLanguageInfo, changeTabsSelectedId, setLangState } from '../../../redux/actions/getAppPublicData';
import { store } from '../../../redux/store'
import utils from "../../../utils/utils";
import Language from '../../../i18n/Language';
import flexNavIcon from "../../../assets/flexNavIcon";

const t = Language
// new图标
// const newIcon = <span style={{ position: 'absolute', top: "0", right: "0" }}><svg t="1608603465778" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7978" width="26" height="26"><path d="M1020.586667 413.013333l-409.6-409.6c-3.413333 0-10.24-3.413333-13.653334-3.413333H17.066667C10.24 0 3.413333 3.413333 0 10.24c0 6.826667 0 13.653333 3.413333 20.48l989.866667 989.866667c3.413333 3.413333 6.826667 3.413333 13.653333 3.413333h6.826667c6.826667-3.413333 10.24-10.24 10.24-17.066667v-580.266666c0-3.413333-3.413333-10.24-3.413333-13.653334zM464.213333 334.506667c-3.413333 0-6.826667 0-6.826666-3.413334-6.826667-3.413333-10.24-10.24-6.826667-17.066666l34.133333-160.426667-92.16 92.16c-6.826667 6.826667-17.066667 6.826667-23.893333 0-6.826667-6.826667-6.826667-17.066667 0-23.893333l133.12-133.12c6.826667-6.826667 13.653333-6.826667 20.48-3.413334s10.24 10.24 6.826667 17.066667l-34.133334 160.426667L587.093333 170.666667c6.826667-6.826667 17.066667-6.826667 23.893334 0 6.826667 6.826667 6.826667 17.066667 0 23.893333L477.866667 324.266667c-6.826667 10.24-10.24 10.24-13.653334 10.24z m143.36 34.133333l-37.546666-37.546667-37.546667 37.546667 54.613333 54.613333c6.826667 6.826667 6.826667 17.066667 0 23.893334-3.413333 3.413333-6.826667 3.413333-13.653333 3.413333s-10.24 0-13.653333-3.413333l-68.266667-68.266667c-6.826667-6.826667-6.826667-17.066667 0-23.893333l133.12-133.12c3.413333-3.413333 6.826667-6.826667 13.653333-3.413334 3.413333 0 10.24 3.413333 13.653334 3.413334l71.68 71.68c6.826667 6.826667 6.826667 17.066667 0 23.893333s-17.066667 6.826667-23.893334 0l-61.44-61.44L597.333333 307.2l37.546667 37.546667c6.826667 6.826667 6.826667 17.066667 0 23.893333-3.413333 3.413333-6.826667 3.413333-13.653333 3.413333s-10.24 0-13.653334-3.413333z m290.133334 122.88l-157.013334 105.813333c-3.413333 3.413333-6.826667 3.413333-10.24 3.413334-3.413333 0-6.826667 0-10.24-3.413334-6.826667-3.413333-6.826667-10.24-6.826666-17.066666l27.306666-98.986667-88.746666 34.133333c-6.826667 3.413333-13.653333 0-20.48-6.826666-3.413333-6.826667-3.413333-13.653333 0-20.48l105.813333-157.013334c6.826667-6.826667 17.066667-10.24 23.893333-3.413333 6.826667 6.826667 10.24 17.066667 3.413334 23.893333l-75.093334 112.64 71.68-27.306666c6.826667-3.413333 13.653333 0 17.066667 3.413333s6.826667 10.24 3.413333 17.066667l-23.893333 88.746666 119.466667-81.92c6.826667-6.826667 17.066667-3.413333 23.893333 3.413334 6.826667 6.826667 3.413333 20.48-3.413333 23.893333z" fill="#008000" p-id="7979"></path></svg></span>;

class TopNavBar extends Component {
    state = {
        mobileNavigationActive: false,
        //等级
        level: 0,

        //语言
        selectedLanguage: Boolean(store.getState().public.Language) ? store.getState().public.Language : 'en',
        shopify_level: '',

        //是否显示好评弹窗
        showReview: false,
        //点击打开好评弹窗
        openReview: false,
        //好评弹窗文字
        reviewContent: '',

        //弹窗评价name和邮箱
        modalName: '',
        modalEmail: '',
        modalDefaultEmail: '',

        //用户服务开关
        userServices: '',

        newList: [],
        loadingShowNewsOpen: true,
        countNews: 0,
        languageActive: false,
        //通知功能
        messageStatus: true,
        messageSelected: 0,
        messagePage: 1,
        messageHasMore: true,
        typeTabs: [
            {
                id: 3,
                content: t("Expert service"),
                accessibilityLabel: "All customers",
                panelID: "expert-message-id"
            }, {
                id: 2,
                content: t("Paid Plan"),
                panelID: "paid-message-id"
            }, {
                id: 1,
                content: t("System"),
                panelID: "sys-message-id"
            }],

        messageTotal: {},
        messageUnreadTotal: {},
        firstGetStauts: true,
        couponExpirationTimer: 0,
        // 顶部导航栏
        tabs: [],
        topSelected: 0, // 当前选择的菜单id

        AdvancedActive: false,
        //监听屏幕
        wInnerWidth: window.innerWidth,

        //新手引导遮罩状态
        noviceGuideBackdropStatus: false,
        //是否首次打开新手引导
        isFirstShownoviceGuide: false,
        //是否展示hi模块
        showHi: false,
        //优惠券数据
        showCouponData: false,
        //是否第一次关闭 优惠弹窗 false 没有点击 true 点击
        isFirstCloseConponModal: false,
        // 活动展示状态
        showBlackFridayModal: -1,
        showBlackFridayBanner: -1,

        isExpandedNav: true, // 是否展开左侧导航栏

        windowUrl: window.location.pathname,

        isShakeStatus: false, // 按钮摇动

    }

    componentDidMount() {
        window.addEventListener("resize", this.reSize, true);
        // 获取顶部数据
        this.getHeaderInfo();

        // 传递内部this
        if(this.props.handleTopNavAction) {
            this.props.handleTopNavAction(this);
            window.TopNavAction = this;
        }
        this.shakeFreeBtn("none");
    }

    // 摇动效果
    shakeFreeBtn = (type) => {
        if(type === 'none') {
        setTimeout(() => {
            this.setState({
            isShakeStatus: false,
            }, () => {
            this.shakeFreeBtn('show');
            })
        }, 1000)
        } else {
        setTimeout(() => {
            this.setState({
            isShakeStatus: true,
            }, () => {
            this.shakeFreeBtn('none');
            })
        }, 3000)
        }
    }

    // 更新公共数据
    resetAllData = () => {
        if (this.props.public.resNum > 1) {
            // 获取语言
            this.setSelectLanguage();
            // 获取顶部数据
            this.getHeaderInfo();
        } else {
            setTimeout(() => {
                this.resetAllData();
            }, 1000);
        }
    }

    //用户是否评价
    getHeaderInfo = () => {
        let _store = this.props.public.publicInit;
        if (this.props.public.status) {
            //把service相关服务存储window里
            window.userServices = _store && _store.service_data
            this.setState({
                showReview: _store.head_data.is_review,
                countNews: _store.head_data.notice_num,
                //等级
                level: _store.shop_data.level,
                shopify_level: Boolean(_store.shop_data) && _store.shop_data.plan_display_name,
                userServices: _store.service_data,
                modalEmail: Boolean(_store.shop_data) && _store.shop_data.email,
                modalDefaultEmail: Boolean(_store.shop_data) && _store.shop_data.email,
                isFirstCloseConponModal: Boolean(_store.campaign_data) && _store.campaign_data.coupon_list.coupon_pop ? false : true,
                showCouponData: Boolean(_store.campaign_data) && _store.campaign_data.coupon_list !== undefined ? _store.campaign_data.coupon_list : false,
                showBlackFridayModal: Boolean(_store.campaign_data) && _store.campaign_data.campaign_modal.middle_status ? Number(_store.campaign_data.campaign_modal.middle_status) : -1,
                showBlackFridayBanner: Boolean(_store.campaign_data) && _store.campaign_data.campaign_modal.top_status ? Number(_store.campaign_data.campaign_modal.top_status) : -1,
            }, () => {
                // if (this.state.wInnerWidth < 768) {
                //     if (this.state.isFirstShownoviceGuide) {
                //         this.setState({
                //             noviceGuideBackdropStatus: false,
                //             showHi: false,
                //         })
                //     }
                // } else {
                //     if (this.state.isFirstShownoviceGuide) {
                //         this.setState({
                //             noviceGuideBackdropStatus: true,
                //             showHi: true,
                //         })
                //     }
                // }
            });
            window.email = Boolean(_store.shop_data) && _store.shop_data.email;

            this.setState({
                modalName: window.shopOwner
            });
        } else {
            if (!(_store && _store.ack === 0)) {
                setTimeout(() => {
                    this.getHeaderInfo();
                }, 0)
            }
        }
    }

    // 屏幕监听
    reSize = () => {
        this.setState({
          wInnerWidth: window.innerWidth,
        })
      }

    // 开关导航栏
    toggleNavMenus = (states = false) => {
        this.setState({
            isExpandedNav: !this.state.isExpandedNav,
        }, () => {
            this.props.toggleNavMenus(this.state.isExpandedNav);
            window.isExpandedNav = !this.state.isExpandedNav;
            window.isSetNav = 'isSet';
        })
    }

    //语言转换
    LanguageChangeTransformation = (val) => {
        switch (val) {
            case 'cs': return 'Čeština';
            case 'da': return 'Dansk';
            case 'ge': return 'Deutsch';
            case 'en': return 'English';
            case 'sp': return 'Español';
            case 'fr': return 'Française';
            case 'it': return 'Italian';
            case 'in': return 'India';
            case 'dut': return 'Nederlands';
            case 'nb': return 'Norsk (bokmål)';
            case 'pl': return 'Polski';
            case 'pt_BR': return 'Português (Brasil)';
            case 'pt': return 'Português (Portugal)';
            case 'fi': return 'Suomi';
            case 'sv': return 'Svenska';
            case 'tr': return 'Türkçe';
            case 'th': return 'ภาษาไทย';
            case 'ja': return '日本語';
            case 'zh_hant': return '中文繁体';
            case 'zh': return '中文简体';
            case 'ko': return '한국어';
            default: return 'English';
        }
    };

    //改版 语言选择器
    handleImportedAction = (selectedLanguage) => {
        store.dispatch(setLangState(false)); // 重置语言状态
        this.setState({
            selectedLanguage,
            languageActive: false,
        }, async () => {
            window.language = selectedLanguage;
            this.props.changeLanguageStatus(selectedLanguage); //缓存全局状态
            const params = {
                Language: selectedLanguage,
            };
            const response = await reqUpdateLanguage(params)
            if (response) {}
        })
    }


    //打开通知栏
    openEditContent = () => {
        this.setState({
            newList: [],
            messagePage: 1,
            messageSelected: 0,
            messageHasMore: true,
            messageStatus: true,
            sheetActive: true,
        })
        this.getMessageTabsInfo().then(() => {
            this.setState({
                firstGetStauts: false
            })
            this.getNewsLog(this.state.typeTabs[this.state.messageSelected].id)
        });
    }

    //关闭通知栏
    handleCloseSheet = () => {
        this.setState({
            sheetActive: false
        })
    }


    //切换通知栏分类
    switchMessageTab = (index) => {
        this.setState({
            newList: [],
            messageHasMore: true,
            messagePage: 1,
            messageSelected: index,
            loadingShowNewsOpen: true
        }, () => {
            this.getNewsLog(this.state.typeTabs[this.state.messageSelected].id)
        })
    }

    // 获取用户通知栏信息记录
    getNewsLog = async (selected) => {
        const params = {
            type: selected,
            page: this.state.messagePage
        };
        const response = await reqGetStatisticsMessage(params); 
        if (response.code === 200) {
            const news = response.data;
            let newList = news

            var total = 0;
            if (selected === 1) {
                total = this.state.messageTotal.sysMessage
            }
            if (selected === 2) {
                total = this.state.messageTotal.paidMessage
            }

            if (selected === 3) {
                total = this.state.messageTotal.expertMessage
            }

            if (newList.length === 0 || total === this.state.messagePage * 15) {
                this.setState({
                    messageHasMore: false
                })
            }

            this.setState({
                newList: this.state.newList.concat(newList),
                loadingShowNewsOpen: false,
                messageStatus: false
            })
        }
    }

    //获取通知信息
    getMessageTabsInfo = async () => {
        const params = {}
        const response = await reqGetMessageTabsInfo(params)
        if (response.code === 200) {
            this.setState({
                messageTotal: response.data.total,
                countNews: response.data.unread.unreadCount,
                messageUnreadTotal: response.data.unread
            }, () => {
                this.updateMessageTabs(this.state.messageTotal, this.state.messageUnreadTotal)
            })
        }
    }

    //点击删除消息
    DeleteMessage = async (index, key, selected) => {
        let newList = this.state.newList;
        let messageTotal = this.state.messageTotal
        if (selected === 1) {
            messageTotal.sysMessage -= 1
        }

        if (selected === 2) {
            messageTotal.paidMessage -= 1
        }

        if (selected === 3) {
            messageTotal.expertMessage -= 1
        }

        if (!newList[index].status) {
            let messageUnreadTotal = this.state.messageUnreadTotal
            if (selected === 1) {
                messageUnreadTotal.unreadSysMessage -= 1
            }

            if (selected === 2) {
                messageUnreadTotal.unreadPaidMessage -= 1
            }

            if (selected === 3) {
                messageUnreadTotal.unreadExpertMessage -= 1
            }

            let countNews = this.state.countNews
            countNews -= 1
            this.setState({
                messageUnreadTotal,
                countNews
            })
        }

        this.setState({
            messageTotal
        }, () => {
            this.updateMessageTabs(this.state.messageTotal, this.state.messageUnreadTotal)
        })

        newList.splice(index, 1);

        this.setState({
            newList
        })

        const params = {
            id: key,
            type: selected
        };

        await reqDeleteStatisticsMessages(params);
    }
    updateMessageTabs = (messageTotal, messageUnreadTotal) => {
        let typeTabs = [
            {
                id: 3,
                content: t("Expert service"),
                accessibilityLabel: "All customers",
                panelID: "expert-message-id"
            }, {
                id: 2,
                content: t("Paid Plan"),
                panelID: "paid-message-id"
            }, {
                id: 1,
                content: t("System"),
                panelID: "sys-message-id"
            }]

        if (messageUnreadTotal.unreadSysMessage > 0) {
            typeTabs[2].content = <span>{t("System")} <Badge><span className="MessageBadge">{messageUnreadTotal.unreadSysMessage > 99 ? "99+" : messageUnreadTotal.unreadSysMessage}</span></Badge></span>
        }

        if (messageTotal.paidMessage > 0) {
            if (messageUnreadTotal.unreadPaidMessage > 0) {  //#804CF3  //#008060
                typeTabs[1].content = <span>{t("Paid Plan")} <Badge><span className="MessageBadge">{messageUnreadTotal.unreadPaidMessage > 99 ? "99+" : messageUnreadTotal.unreadPaidMessage}</span></Badge></span>
            }
        } else {
            typeTabs.splice(1, 1)
        }

        if (messageTotal.expertMessage > 0) {
            if (messageUnreadTotal.unreadExpertMessage > 0) {
                typeTabs[0].content = <span>{t("Expert service")} <Badge><span className="MessageBadge">{messageUnreadTotal.unreadExpertMessage > 99 ? "99+" : messageUnreadTotal.unreadExpertMessage}</span></Badge></span>
            }
        } else {
            typeTabs.splice(0, 1)
        }

        let getStatus = false;
        if (this.state.typeTabs[0].id !== typeTabs[0].id && !this.state.firstGetStauts) {
            getStatus = true;
        }

        this.setState({
            typeTabs
        }, () => {
            if (getStatus) {
                this.setState({
                    loadingShowNewsOpen: true
                })
                this.getNewsLog(this.state.typeTabs[this.state.messageSelected].id)
            }
        })
    }

    //点击打开弹窗
    openReviewModal = () => {
        this.setState({
            openReview: true
        })
    }

    //关闭 or 打开
    toggleActive = (languageActiveVal) => {
        this.setState({
            languageActive: languageActiveVal
        })
    }

    //点击跳转更改消息为已读
    clickJumpPage = async (key, selected, path) => { //传入id
        const params = {
            id: key,
            type: selected
        };
        const response = await reqUpdateStatisticsMessages(params);  //更改状态
        if (response.code === 200) {
            this.setState({ sheetActive: false })
            this.props.history.push(path)
        }
    }

    //弹窗组件关闭 子组件传值到父组件
    ChildrenChange = (val) => {//这个val就是子组件传来的
        this.setState({
            openReview: val
        })
    }

    //弹窗组件提交评价成功 子组件传值到父组件 如果有值重新请求接口
    ChildrenReRequest = (val) => {
        //这个val就是子组件传来的
        // if (val) {
        //     this.getHeaderInfo();
        // }
        this.setState({
            showReview: false
        })
    }

    setMobileNavigationActive = () => {
        this.setState(({ mobileNavigationActive }) => ({ mobileNavigationActive: !mobileNavigationActive }));
    }

    toggleMobileNavigationActive = () => {
        // this.setMobileNavigationActive();
        this.props.changeMobileNavStatus(true);
    }

    //滚动加载新数据
    getNextMassLog = () => {
        this.setState({
            messagePage: this.state.messagePage + 1
        }, () => {
            this.getNewsLog(this.state.typeTabs[this.state.messageSelected].id)
        })
    }

    // 关闭
    changeNavStatus = () => {
        this.setState({
            isExpandedNav: false,
        }, () => {
            window.isExpandedNav = false;
        })
    }

    componentWillUnmount() {
        this.setState = () => false;
        window.removeEventListener('resize', this.reSize);
    }

    render() {
        const {
            state: {
                // openReview,
                // // showReview,
                // reviewContent,
                // modalName,
                // modalEmail,
                // modalDefaultEmail,
                typeTabs,
                newList,
                loadingShowNewsOpen,
                countNews,
                sheetActive,
                languageActive,
                messageSelected,
                wInnerWidth,
                isExpandedNav,
            },
            handleCloseSheet,
            switchMessageTab,
        } = this;

        // 礼物icon
        const giftIcon = <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.842651 15.3698H16.1628V0.0496455H0.842651V15.3698Z" fill="url(#pattern0)"/>
            <defs>
            <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
            <use href="#image0_5_131" transform="scale(0.015625)"/>
            </pattern>
            <image id="image0_5_131" width="64" height="64" href="data:image/png;base64,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"/>
            </defs>
        </svg>

        // 获取语言字段 
        const LanguageVal = store.getState().public.Language;
        const activator = (
            <div className="TimeSelectButton">
                <Button onClick={() => this.toggleActive(!languageActive)} disclosure="select" >
                    <Icon source={LanguageMinor} />
                    <p>{this.LanguageChangeTransformation(LanguageVal)}</p>
                </Button>
            </div>
        );
        const TimeSelect = <Popover
            active={languageActive}
            activator={activator}
            onClose={() => this.toggleActive(!languageActive)}
        >
            <ActionList
                actionRole="languageitem"
                items={[
                    {
                        active: LanguageVal === 'cs',
                        content: "Čeština",
                        onAction: () => this.handleImportedAction('cs'),
                    },
                    {
                        active: LanguageVal === 'da',
                        content: "Dansk",
                        onAction: () => this.handleImportedAction('da'),
                    },
                    {
                        active: LanguageVal === 'ge',
                        content: "Deutsch",
                        onAction: () => this.handleImportedAction('ge'),
                    },
                    {
                        active: LanguageVal === 'en',
                        content: "English",
                        onAction: () => this.handleImportedAction('en'),
                    },
                    {
                        active: LanguageVal === 'sp',
                        content: "Español",
                        onAction: () => this.handleImportedAction('sp'),
                    },
                    {
                        active: LanguageVal === 'fr',
                        content: "Française",
                        onAction: () => this.handleImportedAction('fr'),
                    },
                    {
                        active: LanguageVal === 'it',
                        content: "Italian",
                        onAction: () => this.handleImportedAction('it'),
                    },
                    {
                        active: LanguageVal === 'in',
                        content: "India",
                        onAction: () => this.handleImportedAction('in'),
                    },
                    {
                        active: LanguageVal === 'dut',
                        content: "Nederlands",
                        onAction: () => this.handleImportedAction('dut'),
                    },
                    {
                        active: LanguageVal === 'nb',
                        content: "Norsk (bokmål)",
                        onAction: () => this.handleImportedAction('nb'),
                    },
                    {
                        active: LanguageVal === 'pl',
                        content: "Polski",
                        onAction: () => this.handleImportedAction('pl'),
                    },
                    {
                        active: LanguageVal === 'pt_BR',
                        content: "Português (Brasil)",
                        onAction: () => this.handleImportedAction('pt_BR'),
                    },
                    {
                        active: LanguageVal === 'pt',
                        content: "Português (Portugal)",
                        onAction: () => this.handleImportedAction('pt'),
                    },
                    {
                        active: LanguageVal === 'fi',
                        content: "Suomi",
                        onAction: () => this.handleImportedAction('fi'),
                    },
                    {
                        active: LanguageVal === 'sv',
                        content: "Svenska",
                        onAction: () => this.handleImportedAction('sv'),
                    },
                    {
                        active: LanguageVal === 'tr',
                        content: "Türkçe",
                        onAction: () => this.handleImportedAction('tr'),
                    },
                    {
                        active: LanguageVal === 'th',
                        content: "ภาษาไทย",
                        onAction: () => this.handleImportedAction('th'),
                    },
                    {
                        active: LanguageVal === 'ja',
                        content: "日本語",
                        onAction: () => this.handleImportedAction('ja'),
                    },
                    {
                        active: LanguageVal === 'zh_hant',
                        content: "中文繁体",
                        onAction: () => this.handleImportedAction('zh_hant'),
                    },
                    {
                        active: LanguageVal === 'zh',
                        content: "中文简体",
                        onAction: () => this.handleImportedAction('zh'),
                    },
                    {
                        active: LanguageVal === 'ko',
                        content: "한국어",
                        onAction: () => this.handleImportedAction('ko'),
                    }
                ]}
            />
        </Popover>
        
        const stores = this.props.public.publicInit.other_options;
        const pathname = window.location.pathname;
        const current_level = Boolean(store.getState().public.publicInit.shop_data) && store.getState().public.publicInit.shop_data.level;
        const timeState = new Date().getTime() > 1696089599000; // 10月1替换另一个广告
        const BarRightBlock = <div className="Right-TopBar-Content">
            {/* 广告 公共模块 */}
            {(0 && wInnerWidth > 769) ? <div className="dsm_adver" onClick={() => {
                let url = !Boolean(timeState) ? "https://share.dropshipman.com/share?utm_content=2064e570b83fb4cJ5L&utm_source=SeoAnt_partner&utm_campaign=Internal_diversion" : "https://share.channelwill.com/app/336510f56794fcbXaU";
                window.open(url);
            }}>
                {giftIcon}
                <h2>{!Boolean(timeState) ? t("Install Dropshipman to get $100.") : t("Install Loloyal to Boost Loyalty")}</h2> |
                <h2 className="install_now">{t("Install Now")}</h2>
            </div> : null}

            {Boolean(stores) && pathname !== '/plan' && pathname !== '/oldversion/pricing' ?  stores.trial_days !== 0 ? <div className={`SevenFreeButton girafflyshake ${this.state.isShakeStatus ? 'infinite' : ''}`}>
            {/* {1 ?  1 ? <div className={`SevenFreeButton girafflyshake ${this.state.isShakeStatus ? 'infinite' : ''}`}> */}
                <div className="sevenday_trial_btn" onClick={() => {
                    utils.routeJump(this, '/plan')
                }}>
                    <span>{t("Start 7-day Free Trial")}</span>
                    <img src="/rocket_seven.png" alt="rocket_seven" />
                </div>
            </div> : null : null}

           {
                (Boolean(stores) && stores.trial_days === 0) || pathname === '/plan' || pathname === '/oldversion/pricing' ?  
                <div className="user_level_plan">
                    <span>{current_level === 1 ? "Free Plan" : current_level === 2 ? "Pro Plan" : current_level === 3 ? 'Premium Plan' : 'Meal Plan'}</span>
                    <span onClick={() => {
                        utils.routeJump(this, "/plan")
                    }}>{current_level === 3 ? t("Downgrade") : t("Upgrade")}</span>
                </div> : null
           }     


            {/* {pathname !== '/dashboard/integration' ? <div className="TopBar-Review" style={{paddingTop: '5px'}} onClick={() => {
                utils.routeJump(this, "/dashboard/integration")
            }}>
                <img width="30" height="30" src="https://api-admin.seoant.com/file/e178c53c658bcf17eca587a4e80fe6bf49df3a9f3bc71cfab0edc4c51cd80b3b" alt="gif" />
            </div> : null} */}
            <div className="TopBar-Review" onClick={() => { this.openEditContent() }}>
                <div style={{ position: 'relative' }}>
                    <Icon source={News} />
                    {countNews > 0 ? <span className="NewsNum">{countNews > 99 ? "99+" : countNews}</span> : null}
                </div>
            </div>
            {/* {showReview ? <div className="TopBar-Review" onClick={() => { this.openReviewModal() }}>
                <Icon source={StarIcon} />
            </div> : ''} */}
            {/* <div className="TopBar-Pricing">
                <Icon source={MoneyIcon} />
            </div> */}
            {TimeSelect}
        </div>

        const selectLanguage = this.state.loading ? <SkeletonDisplayText size="medium" /> : BarRightBlock;

        //newReview弹窗
        // const newReview =
        //     <NewReviewModal
        //         open={openReview}
        //         changeData={this.ChildrenChange}
        //         content={reviewContent}
        //         reRequest={this.ChildrenReRequest}
        //         modalEmail={modalEmail}
        //         modalName={modalName}
        //         modalDefaultEmail={modalDefaultEmail}
        //     />

        // 邮箱弹窗
        const loadingShowNewsModel = <div  className="DetailReport_Empty_New_div_margin_800">
            <Spinner size="large" color="teal" />
        </div>
        const loadingMarkup = this.state.messageStatus ? (
            <div className="Off-Canvas-Sheet__Container">
                <div className="Off-Canvas-Header">
                    <Text variant="headingMd" as="h2">{t("Message")}</Text>
                    <Button
                        accessibilityLabel="Cancel"
                        icon={MobileCancelMajor}
                        onClick={handleCloseSheet}
                        plain
                    />
                </div>

            <div  className="DetailReport_Empty_New_div_margin_800">
                <Spinner size="large" color="teal" />
            </div>
            </div>
        ) : '';
        const MessageModel = !this.state.messageStatus ? (
            <div className='GetUserAppNews'>
                <div className="Off-Canvas-Header">
                    <Text variant="headingMd" as="h2">{t("Message")}</Text>
                    <Button
                        accessibilityLabel="Cancel"
                        icon={MobileCancelMajor}
                        onClick={handleCloseSheet}
                        plain
                    />
                </div>
                <Tabs tabs={typeTabs} selected={messageSelected} onSelect={switchMessageTab} >
                    {/* {loadingShowNewsOpen? loadingShowNewsModel:newList} */}
                    {loadingShowNewsOpen ? loadingShowNewsModel :
                        <div style={{ height: "calc(100% - 120px)", overflow: 'auto' }} id="GetUserAppNewsId">
                            <InfiniteScroll
                                // pullDownToRefresh
                                // height={500}
                                scrollableTarget="GetUserAppNewsId"
                                dataLength={newList.length}
                                pullDownToRefreshContent={
                                    <h3 style={{ textAlign: 'center' }}>&#8595; Pull down to refresh</h3>
                                }
                                releaseToRefreshContent={
                                    <h3 style={{ textAlign: 'center' }}>&#8593; Release to refresh</h3>
                                }
                                // refreshFunction={this.getNextMassLog()}
                                next={() => { this.getNextMassLog() }}
                                hasMore={this.state.messageHasMore}
                                loader={newList.length ? <div  className="DetailReport_Empty_New_div_margin_800">
                                    <Spinner size="large" color="teal" />
                                </div> : <p style={{ textAlign: 'center' }}>
                                    <b>{t("No data temporarily")}</b>
                                </p>}
                                endMessage={
                                    <p style={{ textAlign: 'center' }}>
                                        <b>{t("There is no more news here")}</b>
                                    </p>
                                }>

                                {newList.map((item, index) => (
                                    <div className="card_section">
                                        <BlockStack gap={100}>
                                            <div className="HeadingNews" key={index}>
                                                <div className="HeadingNewsTop">
                                                    {!item.status ? <Icon source={UnreadIcon}></Icon> : null}
                                                    <Text variant="headingSm" as="h6">{item.title}</Text>
                                                </div>
                                                <Button
                                                    accessibilityLabel="Close"
                                                    icon={CloseNewsIcon}
                                                    onClick={() => { this.DeleteMessage(index, item.id, this.state.typeTabs[this.state.messageSelected].id) }}
                                                    plain
                                                />
                                                {/* <Icon source={CloseNewsIcon}></Icon> */}
                                            </div>
                                            <p>{item.text}</p>
                                            <div className="HeadingNewsBottom">
                                                <p>{item.time}</p>
                                                <p style={{ color: "#005BD3", cursor: "pointer" }} onClick={() => this.clickJumpPage(item.id, this.state.typeTabs[this.state.messageSelected].id, item.path)}>{item.path_text}-&gt;</p>
                                            </div>
                                        </BlockStack>
                                    </div>
                                ))}
                            </InfiniteScroll>
                        </div>
                    }
                </Tabs>
            </div>
        ) : '';
        const newsModel = <section className={this.state.messageStatus ? "Off-Canvas loading animated fadeInRight MessageLoading" : "Off-Canvas loading Message"} style={{ display: sheetActive ? 'block' : 'none' }}>
            <div className="Off-Canvas-Sheet loading Message" role="dialog">
                {loadingMarkup}

                {MessageModel}

            </div>
        </section>;
        const topBarMarkup = wInnerWidth < 10086 ? (
            <div className="_top_bar">
                {/* PC伸缩图标 */}
                <div className={`Nav_toggle ${!isExpandedNav && 'rotateReverse'}`} onClick={() => this.toggleNavMenus(false)}>
                    <Button icon={flexNavIcon}></Button>
                    {/* <Button icon={!isExpandedNav ? MobileHamburgerMajor : MobileCancelMajor}></Button> */}
                </div>
                <TopBar
                    showNavigationToggle={false}
                    onNavigationToggle={this.toggleMobileNavigationActive}
                    secondaryMenu={selectLanguage}
                />
            </div>
        ) : null;


        return (
            <div>
                {topBarMarkup}
                {/* {newReview} */}
                {newsModel}
            </div>
        );
    }


}


const mapStateToProps = state => {
    return state
}

const mapDispatchToProps = dispatch => ({

    // 修改语言状态
    changeLanguageStatus(val) {
        dispatch(changeLanguageInfo(val));
    },

    // 设置缓存tabs id
    changeTabsSelected([sid, ssonid]) {
        dispatch(changeTabsSelectedId([sid, ssonid]))
    }
})

TopNavBar = connect(
    mapStateToProps,
    mapDispatchToProps
)(TopNavBar);

export default withRouter(TopNavBar);